import React, { useContext, useEffect, useState } from "react";
import { Box, SectionHelper, Text, TextButton } from "@wix/design-system"
import SubscriptionContext from "../contexts/subscription-context";
import { navigate } from "@wix/dashboard-sdk";
import Subscription from "../models/subscription";
import PageLoader from "./common/PageLoader";
import WixConfig from "../config/wix";

const TrialExpiryAlert = () => {

  /*
  |--------------------------------------------------------------------------
  | Flag: should show loading?
  |--------------------------------------------------------------------------
  |
  */

  const [shouldShowLoading, setShouldShowLoading] = useState(false);

  /*
  |--------------------------------------------------------------------------
  | Flag: What should next action be?
  |--------------------------------------------------------------------------
  |
  */

  const [shouldUpgrade, setShouldUpgrade] = useState(false);
  const [shouldPay, setShouldPay] = useState(false);

  /*
  |--------------------------------------------------------------------------
  | Subscription details
  |--------------------------------------------------------------------------
  |
  */

  const { numberOfTrialDays, isTrialStarted, isTrialExpired, formattedTrialExpiryDate, isPaid, currentPlan } = useContext(SubscriptionContext);

  /*
  |--------------------------------------------------------------------------
  | Redirect to checkout page
  |--------------------------------------------------------------------------
  |
  */

  const redirectToCheckoutPage = () => {
    setShouldShowLoading(true);
    Subscription.getCheckoutUrl({ productId: currentPlan })
      .then((response) => {
        window.location.href = response.data.checkoutUrl;
      })
      .finally(() => setShouldShowLoading(true));
  }

  /*
  |--------------------------------------------------------------------------
  | Redirect to upgrade page
  |--------------------------------------------------------------------------
  |
  */

  const redirectToUpgradePage = () => {
    navigate(WixConfig.subscriptionPageId);
  }

  useEffect(() => {
      if (isTrialExpired) {
        setShouldPay(true);
        setShouldUpgrade(false);
      }
  }, [isTrialExpired]);

  return <>
    {
      isTrialStarted && !isPaid &&
      <>
        {shouldShowLoading && <PageLoader />}
        <Box marginBottom="20px">
          <SectionHelper
            fullWidth
          >
            <Text weight="bold" size="small">{`Your ${numberOfTrialDays}-days free trial ${isTrialExpired ? 'expired' : 'expires'} on ${formattedTrialExpiryDate}. `}</Text>
            <TextButton
              onClick={() => shouldPay ? redirectToCheckoutPage() : redirectToUpgradePage()}
              underline="always"
              size="small"
            >
              {' Make payment'}
            </TextButton>
          </SectionHelper>
        </Box>
      </>
    }
  </>
}

export default TrialExpiryAlert;